var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDana(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 536.19 536.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2a84c6;\r\n      }\r\n\r\n      .cls-1,\r\n      .cls-2,\r\n      .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #74b9e6;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Dana") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.47,1C153.81,9.36,82,56.31,38.31,128.77,10,175.86-3.38,231.65.73,288.89,10.79,429,131.15,547.53,285.21,535.32c138.22-11,252.28-135.3,240.59-288.23-4.28-56-23.74-102.15-54.94-143.81C456.74,84.41,454,84.1,439.2,68.65c-18.29-19.16-57-41.15-81.65-50.88C324.45,4.71,282.3-2.79,242.47,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.82,190c-3.36,9.7-1.36,117.62-1.36,137.64,0,21.66-4.27,28.42,29.61,40,89.7,30.67,178.52-73.34,267.72-21.88,4.14,2.38,9.17,7.28,10.35-.63l0-138.83c0-14.93,1.34-19.61-8.56-26.51-79.82-55.6-166.25,39.51-247.24,28.84C131.41,204.67,119,189.37,110.82,190Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDana);
export default __webpack_public_path__ + "static/media/payment_dana.11c37d41689084412a7cd069ef61fce9.svg";
export { ForwardRef as ReactComponent };